;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.0";import { scheduleIdle } from '@repo/observability/lazy'

import { lazyInitPostHog } from './lib/observability/posthog.client'

type SentryClientModule = typeof import('./lib/observability/sentry.client')
let sentryClient: SentryClientModule | undefined

// PostHog and Sentry are the app's two largest scripts; both load at idle and both no-op outside
// production.
const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

if (posthogKey || isProduction) {
  scheduleIdle(() => {
    if (posthogKey) {
      lazyInitPostHog(posthog => {
        posthog.init(posthogKey, {
          api_host: '/relay-ph',
          ui_host: 'https://eu.i.posthog.com',
          defaults: '2025-05-24',
          ip: false,
          session_recording: {
            maskAllInputs: true,
            maskTextSelector: '*'
          }
        })

        posthog.register({ app: 'liquidation' })
      })
    }

    if (isProduction) {
      void import('./lib/observability/sentry.client').then(mod => {
        mod.initSentry()
        sentryClient = mod
      })
    }
  })
}

// Next reads this export synchronously at bootstrap, before the lazy Sentry chunk lands —
// transitions before then are dropped rather than deferred.
export function onRouterTransitionStart(
  ...args: Parameters<SentryClientModule['onRouterTransitionStart']>
): void {
  sentryClient?.onRouterTransitionStart(...args)
}
